/**
 * Herald chat DOM markers for analytics / E2E / PDF — single source for attribute names.
 *
 * - Segment: {@link HERALD_MESSAGE_SEGMENT_DATA_ATTR} (`markdown` | `spec`).
 * - Catalog node: {@link HERALD_CATALOG_COMPONENT_DATA_ATTR} (json-render `element.type`).
 * - Catalog subtree: {@link HERALD_UI_DATA_ATTR} = {@link HERALD_UI_VALUE_CATALOG}.
 * - Unknown component fallback: {@link HERALD_CATALOG_UNKNOWN_DATA_ATTR} (empty).
 * - PDF strip: {@link HERALD_PDF_EXCLUDE_DATA_ATTR} / {@link heraldPdfExcludeProps} — subtree omitted before POST HTML.
 */

/** Segment marker (`markdown` assistant prose vs `spec` json-render blocks). */
export const HERALD_MESSAGE_SEGMENT_DATA_ATTR = "data-herald-message-segment";

/** Catalog component key (`element.type`, e.g. HorizontalBar). */
export const HERALD_CATALOG_COMPONENT_DATA_ATTR =
  "data-herald-catalog-component";

/** Groups Herald catalog-rendered UI; always paired with {@link HERALD_UI_VALUE_CATALOG}. */
export const HERALD_UI_DATA_ATTR = "data-herald-ui";

export const HERALD_UI_VALUE_CATALOG = "catalog";

/** Marks unknown-component fallback rows from json-render. */
export const HERALD_CATALOG_UNKNOWN_DATA_ATTR = "data-herald-catalog-unknown";

/** Attribute on roots whose subtree is omitted when cloning assistant HTML for PDF. */
export const HERALD_PDF_EXCLUDE_DATA_ATTR = "data-herald-pdf-exclude";

/** Spread onto element roots whose subtree is omitted when cloning assistant HTML for PDF. */
export const heraldPdfExcludeProps = {
  [HERALD_PDF_EXCLUDE_DATA_ATTR]: "",
} as const;
